import { EventEmitter } from "events";

const eventBus = new EventEmitter();
console.log('event loaded');
export default eventBus;
